const HeaderLogo = ({}) => (
  <div className="flex items-center py-1">
    <div className="relative group cursor-pointer">
      <div className="flex items-center">
        <svg
          className="w-20 h-20 mr-2 text-blue-500"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2L2 7L12 12L22 7L12 2Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2 17L12 22L22 17"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="opacity-80"
          />
          <path
            d="M2 12L12 17L22 12"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <div className="flex flex-col leading-tight">
          <span className="bg-gradient-to-r from-blue-400 via-indigo-500 to-blue-500 bg-clip-text text-transparent text-3xl font-bold">
            VERIFECH
          </span>
          <span className="text-xl font-normal text-blue-400 tracking-widest -mt-1">
            CLM
          </span>
        </div>
      </div>
    </div>
  </div>
);
export default HeaderLogo;
